import { DatePipe, DecimalPipe } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { ApiService, BankingService, IDPeriodDTO, TransactionRequestDTO } from "../../../../../projects/accounting/src/public_api";
import { CachingService } from '../../../../../projects/jv-common/src/lib/services/caching.service';
import { MessageBoxComponent, MessageBoxData } from '../../../../../projects/jv-ui/src/public_api';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { PaymentEditorComponent, PaymentEditorType } from '../../popups/payment-editor/payment-editor.component';
import { DepositsEditorComponent } from './deposits-editor/deposits-editor.component';
import { DetailsEditorComponent, DetailsEditorData } from "./details-editor/details-editor.component";
import { LookupComponent, LookupData } from './lookup/lookup.component';

interface apiRecord {
    ID: number;
    Name: string;
    Address: string;
    DebtToBrand: number;
    DebtToWarehouses: number;
    DebtOfPoints: number;
    DebtOfSellingPoints: number;
    Returned: number;
    TurnOver: number;
    TurnOverOfBrand: number;
    TurnOverOfWareHouses: number;
    Deposits: number;
}

@Component({
    selector: 'app-debt-outlets',
    templateUrl: './outlets.component.html',
    styleUrls: ['./outlets.component.scss']
})
export class OutletsComponent implements OnInit {

    modalRef: BsModalRef;

    constructor(
        private modal: BsModalService,
        private cache: CachingService,
        private api: ApiService,
        private decimal: DecimalPipe,
        private date: DatePipe,
        private banking: BankingService
    ) {
    }

    public dtConfig = null;
    public loading = false;
    public period = null;
    public currentPeriod = null;
    public nextPeriod = null;
    private history = null;

    private CACHE_KEY: string = 'outlet-history';

    private generate_outletname(i: apiRecord) {
        let first = i.Address.split(',')[0];

        let sent = this.period != this.currentPeriod || (this.history != null && typeof this.history['#' + i.ID] != 'undefined' && this.date.transform(this.history['#' + i.ID].lastSent, 'MM-yyyy') == this.nextPeriod);

        return '<b class="' + (sent ? (i.Returned >= i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses ? 'text-success' : 'text-warning') : 'text-danger') + '">' + first + '</b><br><small>' + i.Address.substr(first.length + 1) + '</small>';
    }

    private generate(data: Array<apiRecord>, period) {
        if (period == this.nextPeriod) {
            return {
                data: data,

              xls: i => i == null
                ? ['Mã Quỹ', 'Địa chỉ', 'Nợ thương hiệu', 'Nợ hàng hóa', 'Nợ bán điểm tiền mặt', 'Tổng công nợ', 'Thanh toán đổi điểm', 'Đặt cọc']
                : [i.ID, i.Address, i.DebtToBrand + i.TurnOverOfBrand, i.DebtToWarehouses + i.TurnOverOfWareHouses, i.DebtOfSellingPoints, i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses, i.DebtOfPoints, i.Deposits],

                group: i => {

                    let parts = i.Address.split(',');

                    if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

                    return {parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim()}
                },
                txt: i => i.Address,

                title: 'CÔNG NỢ CỦA CỬA HÀNG THÁNG ' + period,
              columns: [
                {
                  title: '#',
                  class: 'text-center',
                  html: i => i.ID,
                  css: i => 'text-center text-primary'
                },
                    {
                        title: 'Cửa hàng có công nợ',
                        html: function (i) {
                            let first = i.Address.split(',')[0];
                            return '<b>' + first + '</b><br><small>' + i.Address.substr(first.length + 1) + '</small>';
                        },
                    },
                    {
                        title: 'Thương hiệu',
                        class: 'text-right',
                        html: i => this.decimal.transform(i.DebtToBrand + i.TurnOverOfBrand, '1.0-0', 'en-US'),
                        css: i => 'text-right text-danger'

                    },
                    {
                        title: 'Hàng hóa',
                        class: 'text-right',
                        html: i => this.decimal.transform(i.DebtToWarehouses + i.TurnOverOfWareHouses, '1.0-0', 'en-US'),
                        css: i => 'text-right text-danger',

                    },
                    {
                        title: 'Mua điểm',
                        class: 'text-right',
                        html: i => this.decimal.transform(i.DebtOfSellingPoints, '1.0-0', 'en-US'),
                        css: i => 'text-right text-danger',

                    },
                    {
                        title: 'Tổng công nợ',
                        class: 'text-right',
                        html: i => '<b>' + this.decimal.transform(i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>',
                        css: i => 'text-right text-danger',
                        click: i => this.viewDebts(i)
                    },
                    {
                        title: 'Đổi điểm',
                        class: 'text-right',
                        html: i => this.decimal.transform(i.DebtOfPoints, '1.0-0', 'en-US') + (i.DebtOfPoints > 0 ? '<br><small class="text-warning"><i>Khấu trừ công nợ</i></small>' : ''),
                        css: i => 'text-right text-success',
                        click: i => i.DebtOfPoints > 0 && this.convertIntoDebt(i)
                    },

                    {
                        title: 'Đã đặt cọc',
                        class: 'text-right',
                        html: i => '<b>' + this.decimal.transform(i.Deposits, '1.0-0', 'en-US') + '</b><br><small class="text-success"><i>Ghi nhận đặt cọc</i></small>',
                        css: i => 'text-right text-success',
                        click: i => this.collect(i)
                    },
                ],

                footer: data => {
                    let d2b = 0;
                    let d2w = 0;
                    let dosp = 0;
                    let dop = 0;
                    let dps = 0;
                    // DebtOfSellingPoints

                    data.forEach(i => {
                        d2b += i.DebtToBrand + i.TurnOverOfBrand;
                        d2w += i.DebtToWarehouses + i.TurnOverOfWareHouses;
                        dosp += i.DebtOfSellingPoints;
                        dps += i.Deposits;
                        dop += i.DebtOfPoints;

                    });

                    return [
                      { html: '' },
                      { html: '<b>TỔNG</b>' },
                        {html: this.decimal.transform(d2b, '1.0-0', 'en-US'), class: 'text-right text-danger'},
                        {html: this.decimal.transform(d2w, '1.0-0', 'en-US'), class: 'text-right text-danger'},
                        {html: this.decimal.transform(dosp, '1.0-0', 'en-US'), class: 'text-right text-danger'},
                        {
                            html: '<b>' + this.decimal.transform(d2b + d2w + dosp, '1.0-0', 'en-US') + '</b>',
                            class: 'text-right text-danger'
                        },
                        {html: this.decimal.transform(dop, '1.0-0', 'en-US'), class: 'text-right text-success'},
                        {
                            html: '<b>' + this.decimal.transform(dps, '1.0-0', 'en-US') + '</b>',
                            class: 'text-right text-success'
                        },
                    ];
                }
            }
        }

        /*   ==============================  */

        return {
            data: data,

          xls: i => i == null
            ? ['Mã Quỹ', 'Địa chỉ', 'Đặt cọc', 'Nợ thương hiệu', 'Nợ hàng hóa', 'Nợ bán điểm tiền mặt', 'Tổng công nợ', 'Thanh toán đổi điểm', 'Đã thu', 'Chuyển sang kỳ sau']
            : [i.ID, i.Address, i.Deposits, i.DebtToBrand + i.TurnOverOfBrand, i.DebtToWarehouses + i.TurnOverOfWareHouses, i.DebtOfSellingPoints, i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses, i.DebtOfPoints, i.Returned, i.TurnOver],

            group: i => {

                let parts = i.Address.split(',');

                if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

                return {parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim()}
            },

            txt: i => i.Address,

            title: 'CÔNG NỢ CỦA CỬA HÀNG THÁNG ' + period,
          columns: [

            {
              title: '#',
              class: 'text-center',
              html: i => i.ID,
              css: i => 'text-center text-primary'
            },

                {
                    title: 'Cửa hàng có công nợ',
                    html: i => this.generate_outletname(i)
                },
                {
                    title: 'Đặt cọc',
                    class: 'text-right',
                    html: i => i.Deposits == 0 ? '0' : '<b>' + this.decimal.transform(i.Deposits, '1.0-0', 'en-US') + '</b><br><i class="text-primary"><small>Chi tiết</small></i>',
                    css: i => 'text-right',
                    visible: this.period == this.currentPeriod,
                    click: i => {
                        if (i.Deposits > 0) this.viewDeposits(i);
                    }
                },
                {
                    title: 'Thương hiệu',
                    class: 'text-right',
                    html: i => this.decimal.transform(i.DebtToBrand + i.TurnOverOfBrand, '1.0-0', 'en-US'),
                    css: i => 'text-right text-danger'

                },
                {
                    title: 'Hàng hóa',
                    class: 'text-right',
                    html: i => this.decimal.transform(i.DebtToWarehouses + i.TurnOverOfWareHouses, '1.0-0', 'en-US'),
                    css: i => 'text-right text-danger',

                },
                {
                    title: 'Mua điểm',
                    class: 'text-right',
                    html: i => this.decimal.transform(i.DebtOfSellingPoints, '1.0-0', 'en-US'),
                    css: i => 'text-right text-danger',

                },
                {
                    title: 'Tổng công nợ',
                    class: 'text-right',
                    html: i => '<b>' + this.decimal.transform(i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>',
                    css: i => 'text-right text-danger',
                    click: i => this.viewDebts(i)
                },
                {
                    title: 'Đổi điểm',
                    class: 'text-right',
                    html: i => this.decimal.transform(i.DebtOfPoints, '1.0-0', 'en-US') + (i.DebtOfPoints > 0 ? '<br><small class="text-warning"><i>Khấu trừ công nợ</i></small>' : ''),
                    css: i => 'text-right text-success',
                    click: i => i.DebtOfPoints > 0 && this.convertIntoDebt(i)

                },

                {
                    title: 'Đã thu',
                    class: 'text-right',
                    html: i => '<b>' + this.decimal.transform(i.Returned, '1.0-0', 'en-US') + '</b>',
                    css: i => 'text-right text-success'
                },

                {
                    title: 'Chuyển sang kỳ sau',
                    class: 'text-right',
                    visible: this.currentPeriod != this.period && this.nextPeriod != this.period,
                    html: i => i.TurnOver > 0 ? '<b class="text-warning">' + this.decimal.transform(i.TurnOver, '1.0-0', 'en-US') + '</b><br><small class="text-danger"><i>Hủy chuyển kỳ</i></small>' : '0' + (Math.round(this.getRemainingDebt(i)) > 0 ? '<br><small class="text-warning"><i>Tạo chuyển kỳ</i></small>' : ''),
                    css: i => 'text-right',
                    click: i => i.TurnOver > 0 ? this.deleteTurnOver(i) : this.createTurnOver(i)
                },

                {
                    title: 'Thiếu',
                    class: 'text-right',
                    html: i => {

                        let left = i.DebtToWarehouses + i.DebtOfSellingPoints + i.DebtToBrand + i.TurnOverOfBrand + i.TurnOverOfWareHouses - i.Returned - i.TurnOver -i.DebtOfPoints;
                        return Math.round(left) <= 0 ? '0' : '<b class="text-danger">' + this.decimal.transform(left, '1.0-0', 'en-US') + '</b>' + (i.TurnOver > 0 ? '' : '<br><small class="text-success"><i>' + (this.period != this.nextPeriod ? 'Ghi nhận thu' : 'Ghi nhận đặt cọc') + '</i></small>');
                    },
                    css: i => 'text-right',
                    click: i => {

                        let left = i.DebtToWarehouses + i.DebtOfSellingPoints + i.DebtToBrand + i.TurnOverOfBrand + i.TurnOverOfWareHouses - i.Returned - i.TurnOver -i.DebtOfPoints;
                        if (i.TurnOver == 0 && left > 0) this.collect(i);
                    }
                },
                {
                    title: 'Thừa',
                    class: 'text-right',
                    html: i => {
                        let ovp = i.Returned + i.TurnOver + i.DebtOfPoints - i.DebtOfSellingPoints - i.DebtToWarehouses - i.DebtToBrand - i.TurnOverOfBrand - i.TurnOverOfWareHouses;
                        return Math.round(ovp) < 0 ? '0' : Math.round(ovp) > 10000 ? '<b class=" text-warning">' + this.decimal.transform(ovp, '1.0-0', 'en-US') + '</b>' : this.decimal.transform(ovp, '1.0-0', 'en-US');
                    },
                    css: i => 'text-right',
                }
            ],

            footer: data => {
                let d2b = 0;
                let d2w = 0;
                let dosp = 0;
                let dop = 0;
                let rtn = 0;
                let ovp = 0;
                let tov = 0;
                let dps = 0;


                data.forEach(i => {
                    d2b += i.DebtToBrand + i.TurnOverOfBrand;
                    d2w += i.DebtToWarehouses + i.TurnOverOfWareHouses;
                    dosp += i.DebtOfSellingPoints;
                    dop += i.DebtOfPoints;
                    rtn += i.Returned;
                    tov += i.TurnOver;
                    dps += i.Deposits;


                    let left = i.DebtToBrand + i.DebtOfSellingPoints + i.DebtToWarehouses + i.TurnOverOfBrand + i.TurnOverOfWareHouses - i.Returned - i.TurnOver - i.DebtOfPoints;

                    if (left < 0) ovp -= left;
                });

              return [
                {html: ''},
                    {html: '<b>TỔNG</b>'},
                    {
                        html: '<b>' + this.decimal.transform(dps, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right',
                        visible: this.period == this.currentPeriod
                    },
                    {html: this.decimal.transform(d2b, '1.0-0', 'en-US'), class: 'text-right text-danger'},
                    {html: this.decimal.transform(d2w, '1.0-0', 'en-US'), class: 'text-right text-danger'},
                    {html: this.decimal.transform(dosp, '1.0-0', 'en-US'), class: 'text-right text-danger'},

                    {
                        html: '<b>' + this.decimal.transform(d2b + d2w +dosp, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right text-danger'
                    },
                    {html: this.decimal.transform(dop, '1.0-0', 'en-US'), class: 'text-right text-success'},
                    {
                        html: '<b>' + this.decimal.transform(rtn, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right text-success'
                    },

                    {
                        html: '<b>' + this.decimal.transform(tov, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right text-warning',
                        visible: this.period != this.nextPeriod && this.period != this.currentPeriod
                    },

                    {
                        html: '<b>' + this.decimal.transform(d2b + d2w + dosp  - dop - rtn - tov + ovp, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right text-danger'
                    },
                    {
                        html: '<b>' + this.decimal.transform(ovp, '1.0-0', 'en-US') + '</b>',
                        class: 'text-right text-warning'
                    },
                ];
            }
        }
    }

    private getRemainingDebt(record) {
        return record.DebtToBrand + record.TurnOverOfBrand + record.DebtToWarehouses + record.TurnOverOfWareHouses - record.Returned;
    }

    ngOnInit() {

        let anchor = new Date();

        this.nextPeriod = this.date.transform(anchor, "MM-yyyy");

        anchor.setMonth(anchor.getMonth() - 1);

        this.currentPeriod = this.date.transform(anchor, "MM-yyyy");

        /* use to regenerate history data
        this.cache.get("outlet-payment-history", {}).subscribe(banks => {
          this.cache.get("outlet-emails").subscribe(emails => {

            for (let o in emails) {
              this.history['#' + o] = {
                bank: null,
                emails: emails[o],
                lastSent: 0
              }
            }

            for (let o in banks) {
              if (typeof this.history[o] == 'undefined') this.history[o] = {
                bank: null,
                emails: [],
                lastSent: 0
              }

              this.history[o].bank = banks[o]
            }

            this.cache.set(this.CACHE_KEY, this.history).subscribe(succeed => { });
          });
        });
        */
    }
    load(period) {

        this.dtConfig = null;
        this.loading = true;
        this.api.debtOfOutlets(period).subscribe(response => {
            if (response.succeed) {
                this.period = period;

                if (this.history == null) {
                    this.cache.get(this.CACHE_KEY, null).subscribe(data => {

                        this.history = data;
                        this.dtConfig = this.generate(response.data.sort((a, b) => this.getRemainingDebt(a) > this.getRemainingDebt(b) ? -1 : this.getRemainingDebt(a) < this.getRemainingDebt(b) ? 1 : 0), period);
                    });
                }
                else {
                    this.dtConfig = this.generate(response.data.sort((a, b) => this.getRemainingDebt(a) > this.getRemainingDebt(b) ? -1 : this.getRemainingDebt(a) < this.getRemainingDebt(b) ? 1 : 0), period);
                }
            }

            this.loading = false;
        });
    }

    createTurnOver(i) {

        if (i.Returned + i.TurnOver - i.DebtToWarehouses - i.DebtOfSellingPoints - i.DebtToBrand - i.TurnOverOfWareHouses - i.TurnOverOfBrand < 0) {
            this.loading = true;
            this.api.createTurnOver({ID: i.ID, Period: this.period}).subscribe(data => {
                if (data) {
                    this.load(this.period);
                }
                else {
                    this.loading = false;
                }
            });
        }
    }

    deleteTurnOver(i) {
        if (i.TurnOver > 0) {
            this.loading = true;
            this.api.deleteTurnOver({ID: i.ID, Period: this.period}).subscribe(response => {
                if (response.succeed && response.data) {
                    this.load(this.period);
                }
                else {
                    this.loading = false;
                }
            })
        }
    }

    collect(record: apiRecord) {

        let lines = record.Address.split(',');

        if (record.TurnOver > 0 && this.period != this.currentPeriod) {

            this.error("Công nợ tháng " + this.period + " của " + lines[0] + " đã được chuyển sang thu ở kỳ sau");
            return;
        }
        this.modalRef = this.modal.show(PaymentEditorComponent, {
            class: 'modal-md',
            initialState: {
                data: {
                    name: lines[0],
                    shortName: record.Name,
                    address: lines.length > 1 ? record.Address.substr(lines[0].length + 1).trim() : '',
                    type: PaymentEditorType.income,
                    accounts: this.banking.targets,
                    account: this.history == null || typeof this.history["#" + record.ID] == "undefined" ? null : this.history["#" + record.ID].bank,
                    deposit: this.period == this.nextPeriod,
                    amount: this.period == this.nextPeriod ? 0 : Math.max(0, record.DebtToBrand + record.DebtOfSellingPoints + record.DebtToWarehouses + record.TurnOverOfBrand + record.TurnOverOfWareHouses - record.TurnOver - record.Returned)
                }
            }
        }).content.commit.subscribe(rs => {

            if (this.history != null) {

                if (typeof this.history["#" + record.ID] == "undefined") {

                    this.history["#" + record.ID] = {
                        bank: null,
                        emails: [],
                        lastSent: 0
                    }
                }

                if (this.history["#" + record.ID].bank != rs.account) {
                    this.history["#" + record.ID].bank = rs.account;

                    this.cache.set(this.CACHE_KEY, this.history).subscribe(succeed => {
                    });
                }
            }

            this.loading = true;

            let request: TransactionRequestDTO = {
                ID: record.ID,
                Amount: rs.amount,
                Period: this.period,
                Bank: rs.account,
                Date: rs.date
            };

            this.api.collectFromOutlet(request).subscribe(response => {

                this.loading = false;

                if (response.succeed && response.data) {
                    if (this.period == this.nextPeriod) {
                        record.Deposits += rs.amount;
                    }
                    else {
                        record.Returned += rs.amount;
                    }
                }
                else {
                    this.error("Không tạo được " + (this.period == this.nextPeriod ? " đặt cọc" : " ghi nhận thu"));
                }
            }, error => {
                this.loading = false;
                this.error("Không tạo được " + (this.period == this.nextPeriod ? " đặt cọc" : " ghi nhận thu"));
            })
        })
    }
    convertIntoDebt(i){
        let data: MessageBoxData = {
            title: "Xác nhận khấu trừ công nợ" ,
            content: '<div class="text-warning text-center">' +i.Address + ' T'+this.period + '</div><div class="text-center">'+ 'Số tiền: <span class="text-danger">'+this.decimal.transform(i.DebtOfPoints, '1.0-0', 'en-US')+'</span></div>',
            buttons: [{name: "Đồng ý", class: "bg-success"}, {name: "Quay lại", class: "bg-warning"}],
            closable: true,
            header: true
        };
        this.modal.show(MessageBoxComponent, {
            class: 'modal-md', initialState: {
                data: data
            }
        }).content.selected.subscribe( rs => {
            if(rs.name == 'Đồng ý'){
                this.loading = true;
                let request: IDPeriodDTO = {
                    ID: i.ID,
                    Period: this.period,
                };
                this.api.pointsToDebt(request).subscribe(response => {
                    this.loading = false;
                    if (response.succeed && response.data) {
                            this.load(this.period);
                    }
                    else {
                        this.error("Không khấu trừ được công nợ");
                    }
                }, error => {
                    this.loading = false;
                    this.error("Không khấu trừ được công nợ");
                })
            }
        });
    }
    error(message: string) {

        let data: MessageBoxData = {
            title: "LỖI",
            content: '<div class="text-danger text-center">' + message + '</div>',
            buttons: [{name: "OK", class: "bg-danger"}],
            closable: true,
            header: true
        };

        this.modal.show(MessageBoxComponent, {
            class: 'modal-md', initialState: {
                data: data
            }
        });
    }

    viewDeposits(i: apiRecord) {

        this.modal.show(DepositsEditorComponent, {
            class: 'modal-lg',
            initialState: {
                data: {
                    capitalId: i.ID,
                    name: i.Name,
                    address: i.Address,
                    period: this.period,
                    total: i.Deposits
                }
            }
        }).content.closed.subscribe(changed => {
            if (changed) this.load(this.period);
        });
    }

    viewDebts(i: apiRecord) {
        let data: DetailsEditorData = {
            capitalId: i.ID,
            name: i.Name,
            address: i.Address,
            period: this.period,
            // period: this.fakePeriod,
            debtToBrand: i.DebtToBrand,
            debtToWarehouses: i.DebtToWarehouses,
            debtOfSellingPoints: i.DebtOfSellingPoints,
            turnOverOfWarehouses: i.TurnOverOfWareHouses,
            turnOverOfBrand: i.TurnOverOfBrand,
            debtOfPoints: i.DebtOfPoints,
            returned: i.Returned,
            turnOver: i.TurnOver,
            emails: this.history == null || typeof this.history['#' + i.ID] == "undefined" ? [] : this.history['#' + i.ID].emails
        };

        console.log(data);
        let content = this.modal.show(DetailsEditorComponent, {class: 'modal-lg', initialState: {data: data}}).content;

        if (this.history != null) {

            content.update.subscribe(emails => {

                if (typeof this.history['#' + i.ID] == "undefined") {

                    this.history['#' + i.ID] = {
                        bank: '',
                        emails: [],
                        lastSent: 0
                    }
                }

                this.history['#' + i.ID].emails = emails;
                this.cache.set(this.CACHE_KEY, this.history).subscribe(succeed => {
                });
            });

            content.sent.subscribe(succeed => {
                if (succeed && typeof this.history['#' + i.ID] != 'undefined') {

                    this.history['#' + i.ID].lastSent = new Date().getTime();

                    this.cache.set(this.CACHE_KEY, this.history).subscribe(succeed => {

                        if (succeed && this.period == this.currentPeriod) this.generate(this.dtConfig.data, this.period);
                    });
                }
            });
        }
        content.closed.subscribe(changed => {
            if (changed) this.load(this.period);
        });
    }

    lookup() {

        let data: LookupData = {
            validate: code => this.dtConfig.data.filter(i => i.Name.toUpperCase() == code).length > 0
        };

        this.modal.show(LookupComponent, {
            class: 'modal-md',
            initialState: {data: data}
        }).content.succeed.subscribe(code => {
            this.collect(this.dtConfig.data.filter(i => i.Name.toUpperCase() == code)[0]);
        });
    }
}
